<div class="c-language-menu c-menu-list" [ngClass]="cssClass">
  <div class="c-menu-list__title" i18n="@@common.system_language">Language</div>
  <div class="c-menu-list__content">
    <div
      *ngFor="let language of availableLanguages"
      class="c-menu-list__item justify-content-between align-items-center"
      (click)="selectLanguage(language.code)"
    >
      <span class="d-flex align-items-end">
        <span [ngClass]="currentLanguage === language.code ? 'text-color--primary' : ''">{{ language.name }}</span>
      </span>
      <p500-ui-icon *ngIf="currentLanguage === language.code" name="check" class="ml-5 text-color--primary" size="10px"></p500-ui-icon>
    </div>
  </div>
</div>
